<template>
  <div>
    <el-table :data="userData" style="width: 100%">
      <el-table-column prop="account" label="account" width="150"></el-table-column>
      <el-table-column prop="公告职能模块" label="公告职能模块">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit-outline" size="mini" circle @click="editCate(scope.row)"></el-button>
          <el-tag v-for="(cate, key) in scope.row['公告职能模块']" :key="key + 'ca'" size="mini">{{ cate }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="公告公司" label="公告公司">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit-outline" size="mini" circle @click="editCompany(scope.row)"></el-button>
          <el-tag v-for="(com, key) in scope.row['公告公司']" :key="key + 'co'" size="mini">{{ com }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      class="radish-dia"
      :title="'修改' + (this.currentRow ? this.currentRow.account : '') + '公告职能模块'"
      top="70px"
      :close-on-click-modal="false"
      :modal="false"
      :visible.sync="dialogVisible"
    >
      <el-form>
        <el-form-item v-if="currentRow" label="职能模块">
          <el-select v-model="currentRow['公告职能模块']" multiple filterable placeholder="请选择">
            <el-option v-for="item in categories" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="saveCate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      userData: [],
      categories: [],
      dialogVisible: false,
      currentRow: null,
    }
  },
  mounted: async function() {
    if (!app.categories) {
      await app.getCats()
    }
    this.categories = app.categories.map(cate => cate['名称'])
    this.loadUsers()
  },
  methods: {
    loadUsers: async function() {
      const res = await app.service('misc').listUsers()
      // console.log(res)
      if (res.status == 'success') {
        this.userData = res.data.map(user => {
          if (!user['公告职能模块']) {
            user['公告职能模块'] = []
          }
          if (!user['公告公司']) {
            user['公告公司'] = []
          }
          return user
        })
      }
    },
    editCate: function(row) {
      this.currentRow = row
      this.dialogVisible = true
    },
    editCompany: function(row) {
      this.currentRow = row
      app.root.$refs.selectCompany.open(this.currentRow['公告公司'] || [], companies => {
        this.currentRow['公告公司'] = companies
        this.saveCompany(companies)
      })
      // app.root.$refs.targetCompany.show({
      //   defaultCompanies: this.currentRow['公告公司'] || [],
      //   onConfirm: companies => {
      //     // console.log(companies)
      //     this.currentRow['公告公司'] = companies
      //     this.saveCompany(companies)
      //   },
      // })
    },
    saveCate: async function() {
      const res = await app.service('misc').modifyUser({
        account: this.currentRow.account,
        data: { 公告职能模块: this.currentRow['公告职能模块'] },
      })
      if (res.status === 'success') {
        this.$message.success('修改成功')
        this.dialogVisible = false
      } else {
        this.$message.error(res.msg)
      }
    },
    saveCompany: async function(companies) {
      const res = await app.service('misc').modifyUser({
        account: this.currentRow.account,
        data: { 公告公司: companies },
      })
      if (res.status === 'success') {
        this.$message.success('修改成功')
        this.dialogVisible = false
      } else {
        this.$message.error(res.msg)
      }
    },
  },
}
</script>
